import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Card, CardActionArea, CardActions, CardContent, CardMedia, Divider, Stack, } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useStore, } from '@mcn-platform/models';
import { getType } from 'mobx-state-tree';
import AssetImage from '../../common/asset/AssetImage';
import CustomButton from '../../common/CustomButton';
import ItemInstructors from './ItemInstructors';
import ItemHeadline from './ItemHeadline';
import ItemTitle from './ItemTitle';
import ItemPrice from './ItemPrice';
import { configureSalesCard } from '../../common/portalConfig';
import ItemInfo from './ItemInfo';
const VerticalMediaCard = ({ item, size = 'large', config, customStyle, }) => {
    const { currentPortal, getProgressLink } = useStore();
    const navigate = useNavigate();
    const location = useLocation();
    const { courseCardShowTitle, courseCardShowInstructor, courseCardShowImage, courseCardShowDesc, courseCardShowInfoBar, courseCardShowActionButton, courseCardMaxLinesDescription, courseCardShowPrice, } = config || currentPortal;
    if (!(currentPortal && item)) {
        return null;
    }
    // item can be either a item in a category
    // (that contains a course or program)
    // or simply the course or item directly.
    // for the Document's search, the items has an asset,
    // but it needs to render the item.
    let targetItem;
    if (item.isDocument && item.isDocument()) {
        targetItem = item;
    }
    else {
        targetItem = item.course || item.program || item.microcast
            || item.meeting || item.asset || item.document || item;
    }
    // console.log('ItemType', getType(targetItem));
    if (!targetItem || getType(targetItem).name === 'Item') {
        console.log('targetItem not loaded', targetItem);
        return null;
    }
    if (targetItem.syncState !== 'loaded') {
        console.log('targetItem not loaded', targetItem);
        return null;
    }
    // const itemProgress = getItemProgress(targetItem);
    // console.log('targetItem', {
    //   targetItem,
    //   image: targetItem?.itemImage(),
    // });
    const progressLink = getProgressLink(targetItem.key);
    const { progress: itemProgress } = progressLink;
    const { name, headline, description, price, sellPrice, } = targetItem;
    const { showPrice, showButton, buttonLabel, action, instructorAction, } = configureSalesCard(currentPortal, targetItem, itemProgress, navigate, location, '.');
    return (_jsxs(Card, { sx: {
            width: '100%',
            boxShadow: 'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px !important',
        }, children: [_jsx(CardActionArea, { onClick: () => {
                    if (action) {
                        action();
                    }
                }, children: _jsx(CardMedia, { children: courseCardShowImage && (_jsx(AssetImage, { asset: targetItem?.itemImage(), customStyle: { width: '100%', height: '200px', objectFit: 'cover' }, size: "thumb400w" })) }) }), _jsxs(CardContent, { sx: { pb: 1, ...customStyle }, children: [courseCardShowTitle && (_jsx(ItemTitle, { title: name })), courseCardShowInstructor && (_jsx(Stack, { direction: "column", sx: {
                            minHeight: 24,
                        }, children: targetItem?.instructors?.length ? (_jsx(ItemInstructors, { size: size, instructors: [targetItem?.instructors[0]], showAvatar: false, instructorAction: instructorAction })) : '' })), courseCardShowDesc && (_jsx(ItemHeadline, { showTitle: false, headline: headline, description: description, size: size, maxLines: courseCardMaxLinesDescription })), courseCardShowInfoBar && (_jsxs(_Fragment, { children: [_jsx(Divider, { sx: { marginY: 1 } }), _jsx(ItemInfo, { item: targetItem }), _jsx(Divider, { sx: { marginTop: 1 } })] }))] }), courseCardShowActionButton && (_jsxs(CardActions, { sx: {
                    marginBottom: 1,
                    alignItems: 'center',
                    flexDirection: 'column',
                }, children: [(showPrice && courseCardShowPrice) && (_jsx(Stack, { sx: { minHeight: '36px' }, children: _jsx(ItemPrice, { variant: "text", price: price, sellPrice: sellPrice }) })), showButton && (_jsx(CustomButton, { variant: "outlined", label: buttonLabel, onClick: () => action && action(), customStyle: { width: '100%' } }))] }))] }));
};
VerticalMediaCard.defaultProps = {
    config: undefined,
    customStyle: undefined,
};
export default observer(VerticalMediaCard);
//# sourceMappingURL=VerticalMediaCard.js.map